import { useCallback, useEffect } from 'react'

import useGetInstagramAccounts from '../../../../../../hooks/instagramAccountsHooks/useGetInstagramAccounts'

import { FB_PAGE_CHOICE, INSTA_ACCOUNT_CHOICE } from '../../../fields'

export const usePreselectFirstInstagramAccountOnFacebookPageChange = ({ formik }) => {
  const { values, setFieldValue } = formik

  const { selectedInstagramAccounts } = useGetInstagramAccounts(values[FB_PAGE_CHOICE])
  const instagramAccountsWasLoaded = selectedInstagramAccounts?.wasLoaded
  const instagramAccounts = selectedInstagramAccounts?.results
  const firstInstagramAccountId = instagramAccounts?.[0]?.id
  const selectedInstagramAccountId = values[INSTA_ACCOUNT_CHOICE]

  const onUpdateFacebookPageHandler = useCallback(() => {
    // clear instagram account when facebook page changes
    setFieldValue(INSTA_ACCOUNT_CHOICE, '')
  }, [setFieldValue])

  useEffect(() => {
    if (!selectedInstagramAccountId && instagramAccountsWasLoaded && firstInstagramAccountId) {
      setFieldValue(INSTA_ACCOUNT_CHOICE, firstInstagramAccountId)
    }
  }, [firstInstagramAccountId, instagramAccountsWasLoaded, selectedInstagramAccountId, setFieldValue])

  return { onUpdateFacebookPageHandler, instagramAccountsWasLoaded }
}
